import styled from 'styled-components'
import { blue, blueDark, textMuted, white } from '@/theme/colors'
import { fontMono } from '@/theme/fonts'
import { radii, shadows } from '@/theme/tokens'
import { fontSizes, leading } from '@/theme/typography'
import { Button } from '@components/Button'

/** Styles for the admin itinerary-import detail page. */

/** Pasted text and the raw model response: preformatted, wrapped, and capped in height. */
export const TextBlock = styled.pre`
	margin: 0;
	padding: 12px 16px;
	max-height: 480px;
	overflow: auto;
	border-radius: ${radii.small};
	background-color: ${textMuted}14;
	font-family: ${fontMono};
	font-size: ${fontSizes.caption};
	line-height: ${leading.body};
	color: ${blueDark};
	white-space: pre-wrap;
	overflow-wrap: anywhere;
`

export const FileGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
	gap: 16px;
`

/** One uploaded file: opens the blob in a new tab. */
export const FileTile = styled.a`
	display: flex;
	flex-direction: column;
	gap: 8px;
	color: ${blue};
	text-decoration: none;

	&:hover span {
		text-decoration: underline;
	}
`

export const Thumbnail = styled.img`
	width: 100%;
	height: 180px;
	object-fit: cover;
	border-radius: ${radii.small};
	box-shadow: ${shadows.inner};
	background-color: ${white};
`

/** Stands in for a thumbnail when the file can't be drawn (PDF, text, HEIC). */
export const FilePlaceholder = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 180px;
	border-radius: ${radii.small};
	background-color: ${textMuted}14;
	color: ${textMuted};
	font-size: ${fontSizes.small};
	font-weight: 700;
`

export const FileCaption = styled.span`
	font-size: ${fontSizes.small};
	font-weight: 700;
`

export const CardHeaderRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	margin-bottom: 16px;

	h2 {
		margin: 0;
	}
`

export const ToggleButton = styled(Button).attrs({ variant: 'secondary' as const, size: 'sm' as const })``
